<template>
  <container :class="['page-wrapper']">
    <container>
      <flex :spacing="3">
        <flex-col :span="24">
          <test-toolbar>
            <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.cover" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="cover" /><!--
            --><dropdown :class="['mx-1']" v-if="ready" width="90px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="aspectRatio" :items="aspectRatios" />
          </test-toolbar>
        </flex-col>
        <flex-col equal-height md8 sm12 xs24 :span="6" v-for="(image, index) in images" :key="index">
          <card full-height>
            <card-text>
              <lazy-image
                @loaded="onLoaded"
                @error="onError"
                @click="onClick({src: image, index})"
                :src="image.replace('/static', `${$root.config.staticAssetsDir}`)"
                :title="image"
                :cover="cover"
                :aspect-ratio="aspectRatio[0]"
                :placeholder-bg-color="$dark ? 'black' : 'white'"
                :placeholder-bg-color-lightness="null"
                :placeholder-icon-color="$root.colors.primary"
                :placeholder-icon-color-lightness="$root.colors.bgColorLightness"
                :class="['cursor-pointer']" />
            </card-text>
          </card>
        </flex-col>
      </flex>
    </container>
    <dialog-box
      modal
      padding-off
      persistent
      v-model="dialog"
      :title="$lang.galleryWithLazyImageAndDialog"
      :title-bg-color="$root.colors.primary"
      :title-bg-color-lightness="$root.colors.bgColorLightness">
      <template v-slot:content>
        <table-layout y-align="middle" :class="['bg-black']">
          <row>
            <cell>
              <btn :disabled="imageInDialog.index === 0" @click="loadImage()" :title="$lang.previous" color="white" :class="['m-2']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" icon="chevron-left" size="xl" />
            </cell>
            <cell full-width>
              <lazy-image
                v-if="imageInDialog"
                :src="imageInDialog.src"
                :placeholder-bg-color="$dark ? 'black' : 'white'"
                :placeholder-bg-color-lightness="null"
                :placeholder-icon-color="$root.colors.primary"
                :placeholder-icon-color-lightness="$root.colors.bgColorLightness" />
            </cell>
            <cell>
              <btn :disabled="imageInDialog.index === images.length - 1" @click="loadImage(true)" :title="$lang.next" color="white" :class="['m-2']" :bg-color="$root.colors.primary" :color-lightness="null" :bg-color-lightness="$root.colors.bgColorLightness" icon="chevron-right" size="xl" />
            </cell>
          </row>
        </table-layout>
      </template>
    </dialog-box>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageLazyImage',
  mixins: [
    methods
  ],
  data () {
    return {
      dialog: false,
      images: [],
      cover: true,
      ready: false,
      imageInDialog: {},
      aspectRatio: ['5:3'],
      aspectRatios: ['16:9', '9:16', '1:1', '16:10', '2:1', '2.35:1', '1.85:1', '2.39:1', '5:3', '5:4', '4:3', '3:2', '3:1']
    }
  },
  mounted () {
    this.getExternalData('lazy-image.json', 'images', 'GET', () => {
      this.aspectRatios = this.aspectRatios.sort().map(text => {
        return {text, value: text}
      })
      this.$nextTick(() => {
        this.ready = true
      })
    })
  },
  methods: {
    onLoaded ($event) {
      this.log('loaded', 'lazy-image', $event)
    },
    onError ($event) {
      this.log('error', 'lazy-image', $event)
    },
    onClick (image) {
      this.imageInDialog = {
        src: image.src,
        index: image.index,
        prevIndex: image.index - 1,
        nextIndex: image.index + 1
      }
      this.dialog = true
      this.log('click', 'lazy-image', this.imageInDialog)
    },
    loadImage (next) {
      const index = this.imageInDialog[next ? 'nextIndex' : 'prevIndex']
      this.imageInDialog = {
        index,
        src: this.images[index],
        prevIndex: index - 1,
        nextIndex: index + 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/lazy-image.vue